import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useState } from 'react';
import { MdUpdate } from 'react-icons/md';
import { TbCalculator } from 'react-icons/tb';
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { fDate } from '../../utils/formatTime';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';

export default function CallCenterToolbar({
  filterName,
  onFilterName,
  parent,
  filterDatesRange,
  setFilterDatesRange,
  selectLoanType,
  setSelectLoanType,
  onFilterLoan,
  selectSource,
  onFilterSource,
  selectStatus,
  setSelectStatus,
  onFilterStatus,
  selected,
  setSelectSource,
  setFilterName
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);

  const { SourceDrop, StatusDrop, LoanTypeData } = useGlobalSelector();

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setSelectSource(' ');
    setSelectStatus(' ');
    setFilterName('');
    setSelectLoanType(' ');
  };

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2} pb={1}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={3}>
              <Select
                fullWidth
                size="small"
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectSource}`
                }}
                value={selectSource}
                onChange={onFilterSource}
              >
                <MenuItem value=" " disabled>
                  Select Source
                </MenuItem>
                {SourceDrop.length > 0 &&
                  SourceDrop?.map((item) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Select
                fullWidth
                size="small"
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectLoanType}`
                }}
                value={selectLoanType}
                onChange={onFilterLoan}
              >
                <MenuItem value=" " disabled>
                  Select Loan Type
                </MenuItem>

                {LoanTypeData?.length > 0 &&
                  LoanTypeData?.map((item) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={2.5}>
              <Select
                fullWidth
                size="small"
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectStatus}`
                }}
                value={selectStatus}
                onChange={onFilterStatus}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>
                {StatusDrop?.length > 0 &&
                  StatusDrop?.map((item) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={0.5} display="flex" justifyContent="center">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          gap: 2,
          p: { xs: 2, sm: 2.5 },
          bgcolor: '#ffffff'
        }}
      >
        <Box display="flex" gap={1.25} flexWrap="wrap" alignItems="center">
          <Button
            variant="outlined"
            disabled={selected && selected.length < 1}
            onClick={() => {
              localStorage.setItem('selectedItem', JSON.stringify(selected));
              navigate(`/${parent}/update`);
            }}
            startIcon={<MdUpdate size={18} />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#475569',
              borderColor: '#e2e8f0',
              bgcolor: '#ffffff',
              px: 1.75,
              py: 0.8,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.04)',
                color: '#0284c7'
              }
            }}
          >
            Update ({selected?.length || 0})
          </Button>

          <Button
            variant="outlined"
            onClick={() => {
              window.open(`http://reco.kalolytic.com/`, `_blank`);
            }}
            startIcon={<TbCalculator size={18} />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#475569',
              borderColor: '#e2e8f0',
              bgcolor: '#ffffff',
              px: 1.75,
              py: 0.8,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.04)',
                color: '#0284c7'
              }
            }}
          >
            Recommendation
          </Button>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          gap={1.5}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          <TextField
            size="small"
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Call List..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon icon={searchFill} style={{ color: '#94a3b8', fontSize: 18 }} />
                </InputAdornment>
              )
            }}
            sx={{
              width: { xs: '100%', sm: 260 },
              '& .MuiOutlinedInput-root': {
                bgcolor: '#fff',
                borderRadius: '10px',
                fontSize: '13px',
                '& fieldset': { borderColor: '#e2e8f0' },
                '&:hover fieldset': { borderColor: '#cbd5e1' },
                '&.Mui-focused fieldset': { borderColor: '#0284c7' }
              }
            }}
          />

          <Button
            variant="outlined"
            onClick={() => openFilter(!isOpenFilter)}
            startIcon={<Icon icon={roundFilterList} />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: isOpenFilter ? '#0284c7' : '#475569',
              borderColor: isOpenFilter ? '#0284c7' : '#e2e8f0',
              bgcolor: isOpenFilter ? 'rgba(2, 132, 199, 0.06)' : '#fff',
              height: 40,
              px: 2,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.06)',
                color: '#0284c7'
              }
            }}
          >
            Filters
          </Button>
        </Box>
      </RootStyle>
    </>
  );
}
